export const common = {
  nav: {
    searchJobs: 'Search Jobs',
    forEmployers: 'For Employers',
    resources: 'Resources',
    postJob: 'Post a Job',
    login: 'Login',
    register: 'Sign Up',
    employerPanel: 'Employer Panel',
    candidatePanel: 'Candidate Panel',
    adminPanel: 'Admin Panel',
    logout: 'Logout',
    home: 'Home',
    forCompanies: 'For Companies',
    myPanel: 'My Panel',
  },
  hero: {
    badge: '\uD83D\uDD25 +2,500 active jobs in NYC',
    title: 'Connecting Hispanic Talent with Opportunities in NYC',
    subtitle: 'Smart platform with advanced filters and real-time notifications for professionals and employers',
    searchJobsBtn: 'Search Jobs',
    employerBtn: "I'm an Employer",
  },
  search: {
    placeholder: 'Job title, keywords...',
    location: 'All NYC boroughs',
    category: 'All industries',
    searchBtn: 'Search',
    jobsFound: 'jobs found',
    advancedFilters: 'Advanced filters',
    filters: {
      jobType: 'Job type',
      fullTime: 'Full-time',
      partTime: 'Part-time',
      freelance: 'Freelance',
      remote: 'Remote',
      salaryRange: 'Salary range',
      experience: 'Experience level',
      entry: 'Entry Level',
      mid: 'Mid Level',
      senior: 'Senior',
      executive: 'Executive',
      benefits: 'Benefits',
      healthInsurance: 'Health insurance',
      retirement: '401k',
      visaSponsorship: 'Visa sponsorship',
    },
  },
  stats: {
    label: 'IMPACT IN NUMBERS',
    intro: 'EmpleosNYC is the leading platform connecting talented professionals with New York employers. Our commitment is to facilitate job opportunities for the Hispanic community and all professionals looking to grow in the city that never sleeps.',
    activeJobs: 'active jobs',
    activeJobsDesc: 'Vacancies verified daily',
    professionals: 'registered professionals',
    professionalsDesc: 'Active users looking for jobs',
    satisfaction: 'satisfaction rate',
    satisfactionDesc: 'Users satisfied with our service',
    companies: 'companies',
    companiesDesc: 'Employers trusting our platform',
  },
  testimonials: {
    badge: '\u2B50 Success Stories',
    title: 'What our users say about EmpleosNYC',
  },
  cta: {
    title: 'Looking for talent for your company?',
    subtitle: 'Post jobs and connect with the best professionals in New York',
    benefits: {
      dashboard: 'Intuitive control panel',
      realtime: 'Real-time candidate management',
      notifications: 'Instant notifications',
      support: 'Priority support in Spanish',
    },
    button: 'Get Started Now',
    note: 'Sign up for free and post your first job',
  },
  features: {
    sectionTitle: 'Complete platform',
    sectionTitleHighlight: 'to manage',
    sectionSubtitle: 'your entire hiring process',
    employerPanel: 'Employer Panel',
    employerPanelDesc: 'Manage all your vacancies, candidates and conversations from one place',
    realTimeAlerts: 'Real-Time Alerts',
    realTimeAlertsDesc: 'Receive instant notifications when a candidate applies or an employer responds',
    messaging: 'Integrated Messaging',
    messagingDesc: 'Communicate directly with employers or candidates without leaving the platform',
  },
  jobs: {
    new: 'New',
    viewDetails: 'View Details',
    loadingJobs: 'Loading jobs...',
    noJobs: 'No jobs available',
    noJobsDesc: 'New job opportunities coming soon',
    viewMore: 'View more jobs',
    salaryNegotiable: 'Salary negotiable',
    salaryFrom: 'From',
    salaryTo: 'Up to',
    views: 'views',
    applications: 'applications',
    apply: 'Apply',
    alreadyApplied: 'Already Applied',
    fullTime: 'Full Time',
    partTime: 'Part Time',
    contract: 'Contract',
    freelance: 'Freelance',
    internship: 'Internship',
    requirements: 'Requirements',
    benefits: 'Benefits',
    description: 'Job Description',
    aboutCompany: 'About the Company',
    jobDetails: 'Job Details',
    salary: 'Salary',
    location: 'Location',
    type: 'Type',
    category: 'Category',
    postedOn: 'Posted on',
    applyNow: 'Apply Now',
    loginToApply: 'Login to apply',
    registerToApply: 'Sign up to apply',
    backToJobs: 'Back to jobs',
    shareJob: 'Share job',
    similarJobs: 'Similar Jobs',
  },
  footer: {
    tagline: 'Your bridge to employment in NYC',
    newsletter: 'Subscribe to our newsletter',
    newsletterSuccess: 'Thanks for subscribing!',
    newsletterError: 'Error subscribing. Please try again.',
    forProfessionals: 'For Professionals',
    searchJobs: 'Search Jobs',
    createProfile: 'Create Profile',
    careerResources: 'Career Resources',
    forEmployers: 'For Employers',
    postJob: 'Post a Job',
    pricing: 'Plans & Pricing',
    helpCenter: 'Help Center',
    company: 'Company',
    about: 'About Us',
    blog: 'Blog',
    contact: 'Contact',
    legal: 'Legal',
    terms: 'Terms of Use',
    privacy: 'Privacy',
    cookies: 'Cookies',
    copyright: '\u00a9 2026 EmpleosNYC. All rights reserved.',
    visitors: 'Visitors',
    madeWith: 'Made with \u2764\uFE0F in NYC',
    quickLink: 'Website Builder',
  },
  dashboard: {
    panel: 'Panel',
    myJobs: 'My Jobs',
    applications: 'Applications',
    messages: 'Messages',
    searchJobs: 'Search Jobs',
    myApplications: 'My Applications',
    overview: 'Overview',
    users: 'Users',
    jobs: 'Jobs',
    subscriptions: 'Subscriptions',
    reports: 'Reports',
    campaigns: 'Campaigns',
    help: 'Help',
    myProfile: 'My Profile',
    settings: 'Settings',
    contactAdmin: 'Contact Admin',
    signOut: 'Sign Out',
    language: 'Language',
    employer: 'Employer',
    candidate: 'Candidate',
    administrator: 'Administrator',
    employerPanel: 'Employer Panel',
    manageJobs: 'Manage your job listings and applications',
    postJob: 'Post Job',
    totalJobs: 'Total Jobs',
    activeJobs: 'Active Jobs',
    totalApplications: 'Applications',
    totalViews: 'Total Views',
    newApps: 'new',
    stats: 'Statistics',
    payments: 'Payments',
    billing: 'Billing',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    findNextJob: 'Find your next job opportunity in New York',
    checkApplications: 'Check the status of your applications',
    noJobsFound: 'No jobs found',
    adjustFilters: 'Try adjusting your search filters or explore other categories.',
    clearFilters: 'Clear Filters',
    searchingJobs: 'Searching jobs...',
    jobsFound: 'jobs found',
    newMessage: 'New Message',
    communicateWith: 'Communicate directly with',
    employers: 'employers',
    candidates: 'candidates',
    publish: 'Publish',
    loading: 'Loading...',
    candidateGreeting: 'Hello',
    jobsTab: 'Jobs',
    applicationsTab: 'Applications',
    myProfileBtn: 'My Profile',
    availableJobs: 'Available Jobs',
    myApplicationsCount: 'My Applications',
    inReview: 'In Review',
    hires: 'Hires',
    searchByTitle: 'Search by title, company or keyword...',
    cityOrZone: 'City, state or area...',
    jobType: 'Job Type',
    categoryLabel: 'Category',
    advancedFilters: 'Advanced Filters',
    clearAll: 'Clear all',
    salaryRange: 'Salary Range',
    any: 'Any',
    contractType: 'Contract Type',
    modality: 'Modality',
    onSite: 'On-site',
    remote: 'Remote',
    hybrid: 'Hybrid',
    experience: 'Experience',
    noExperience: 'No experience',
    junior: 'Junior',
    intermediate: 'Intermediate',
    senior: 'Senior',
    leadManager: 'Lead / Manager',
    datePosted: 'Date Posted',
    anyDate: 'Any date',
    last24h: 'Last 24 hours',
    last3d: 'Last 3 days',
    lastWeek: 'Last week',
    last14d: 'Last 14 days',
    lastMonth: 'Last month',
    urgentOnly: 'Urgent Only',
    requiredSkills: 'Required Skills',
    searchSkill: 'Search skill...',
    sortRecent: 'Most recent',
    sortSalaryHigh: 'Highest salary',
    sortSalaryLow: 'Lowest salary',
    sortMostApplied: 'Most applied',
    jobFound: 'job found',
    jobsFoundPlural: 'jobs found',
    fullTime: 'Full Time',
    partTime: 'Part Time',
    contract: 'Contract',
    freelance: 'Freelance',
    internship: 'Internship',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{{count}} days ago',
    weeksAgo: '{{count}} wk. ago',
    monthsAgo: '{{count}} month ago',
    monthsAgoPlural: '{{count}} months ago',
    urgent: 'Urgent',
    negotiable: 'Negotiable',
    from: 'From',
    upTo: 'Up to',
    applied: 'Applied',
    apply: 'Apply',
    applyNow: 'Apply Now',
    more: 'more',
    all: 'All',
    pending: 'Pending',
    viewed: 'Viewed',
    reviewed: 'In Review',
    inProgress: 'In Progress',
    hired: 'Hired',
    accepted: 'Accepted',
    rejected: 'Rejected',
    withdrawn: 'Withdrawn',
    incomplete: 'Incomplete',
    noApplicationsYet: 'No applications yet',
    exploreJobs: 'Explore available jobs and apply to opportunities that interest you.',
    noApplicationsFilter: 'No applications with this status.',
    viewDetail: 'View Detail',
    goToPosting: 'Go to Posting',
    withdraw: 'Withdraw',
    withdrawApplication: 'Withdraw Application',
    withdrawReason: 'Indicate the reason why you want to withdraw your application. This information will be visible to the employer.',
    withdrawPlaceholder: 'E.g.: I accepted another offer, Does not meet my salary expectations, etc.',
    cancel: 'Cancel',
    confirmWithdraw: 'Confirm Withdrawal',
    withdrawing: 'Withdrawing...',
    withdrawalReason: 'Withdrawal reason',
    appliedOn: 'Applied',
    viewedByEmployer: 'Viewed by employer',
    salary: 'Salary',
    type: 'Type',
    category: 'Category',
    status: 'Status',
    active: 'Active',
    closed: 'Closed',
    jobDescription: 'Job Description',
    requirements: 'Requirements',
    benefits: 'Benefits',
    contact: 'Contact',
    viewFullPosting: 'View Full Posting',
    close: 'Close',
    loadingApplications: 'Loading applications...',
    activeApps: 'Active',
    newAppsLabel: 'New',
    pendingApps: 'Pending',
    inProgressApps: 'In Progress',
    hiredApps: 'Hired',
    rejectedApps: 'Rejected',
    withdrawnApps: 'Withdrawn',
    noApplications: 'No applications',
    noApplicationsDesc: 'When candidates apply to your jobs, they will appear here with all their professional information.',
    newBadge: 'New',
    match: 'Match',
    experiences: 'experience',
    experiencesPlural: 'experiences',
    yearsExp: 'yrs exp.',
    authorizedUSA: 'Authorized USA',
    moreSkills: 'more',
    appliedOnDate: 'Applied on',
    viewedOnDate: 'Viewed on',
    viewFullProfile: 'View Full Profile',
    sendMessage: 'Send Message',
    markAsViewed: 'Mark as Viewed',
    downloadCV: 'Download CV',
    contactCandidate: 'Contact',
    changeStatus: 'Change Status',
    noResults: 'No results',
    noResultsDesc: 'No applications with the selected filter.',
    viewAllApplications: 'View all applications',
    hiredConfirmation: 'Hire Confirmed!',
    hiredNotificationSent: 'Email notifications sent to',
    andAdmin: 'and the administrator.',
    myJobsTab: 'My Jobs',
    applicationsTab2: 'Applications',
    statsTab: 'Statistics',
    paymentsTab: 'Payments',
    billingTab: 'Billing',
    noJobsPublished: 'No jobs published',
    startPublishing: 'Start by publishing your first job listing',
    title: 'Title',
    location: 'Location',
    statusCol: 'Status',
    applicationsCol: 'Applications',
    viewsCol: 'Views',
    actions: 'Actions',
    edit: 'Edit',
    pause: 'Pause',
    activate: 'Activate',
    delete: 'Delete',
    editJob: 'Edit Job',
    description: 'Description',
    minSalary: 'Minimum Salary',
    maxSalary: 'Maximum Salary',
    applicationEmail: 'Application Email',
    saveChanges: 'Save Changes',
    jobUpdated: 'Job updated successfully',
    inReviewStatus: 'In Review',
    rejectedStatus: 'Rejected',
    inactive: 'Inactive',
    free: 'FREE',
    publishFirstJob: 'Publish Your First Job',
    payPerUse: 'Pay only for what you need',
    pricePerJob: '$5 per job posting',
    noSubscriptions: 'No monthly subscriptions',
    unlimitedCandidates: 'Manage unlimited candidates',
    fullAccess: 'Full access to all features',
    howItWorks: 'How does it work?',
    howItWorksDesc: 'Each time you post a job, you will be charged $5. The job will remain active until you close it or find the ideal candidate. No monthly commitments.',
    publishNow: 'Publish Now',
    totalViewsStat: 'Total Views',
    applicationsStat: 'Applications',
    conversionRate: 'Conversion Rate',
    activeJobsStat: 'Active Jobs',
    total: 'Total',
    average: 'Average',
    performanceByJob: 'Performance by Job',
    analyzePerformance: 'Analyze the performance of each posting',
    days7: '7 days',
    days30: '30 days',
    allTime: 'All',
    noData: 'No data',
    publishFirst: 'Publish your first job to see statistics',
    job: 'Job',
    views: 'Views',
    conversion: 'Conversion',
    performance: 'Performance',
    excellent: 'Excellent',
    good: 'Good',
    normal: 'Normal',
    low: 'Low',
    ofTotal: 'of total',
    aboveAvg: 'Above',
    belowAvg: 'Below',
    ofAverage: 'average',
    tipsToImprove: 'Tips to improve',
    tipTitle: 'Improve the job title to make it more attractive',
    tipShare: 'Share the listing on social media to increase visibility',
    tipRequirements: 'Review the requirements, they might be too restrictive',
    tipRespond: 'Respond quickly to candidates to maintain their interest',
    totalSpending: 'Total Spending',
    fullHistory: 'Full history',
    thisMonth: 'This Month',
    monthlyAvg: 'Monthly Average',
    months: 'months',
    totalPublications: 'Total Publications',
    paid: 'paid',
    freeLabel: 'free',
    monthlySpending: 'Monthly Spending',
    monthlyStatements: 'Monthly Statements',
    noTransactions: 'No transactions',
    noTransactionsDesc: 'When you publish jobs, your monthly statements will appear here.',
    transactions: 'transactions',
    transaction: 'transaction',
    printStatement: 'Print Statement',
    date: 'Date',
    concept: 'Concept',
    method: 'Method',
    amount: 'Amount',
    monthTotal: 'Month Total',
    jobPosting: 'Job posting',
    totalSpent: 'Total Spent',
    paidPublications: 'Paid Publications',
    each: 'each',
    freePublications: 'Free Publications',
    couponOrFirst: 'Coupon or first job',
    allFilter: 'All',
    paidFilter: 'Paid',
    freeFilter: 'Free',
    search: 'Search...',
    export: 'Export',
    noTransactionsFilter: 'No results',
    noTransactionsFilterDesc: 'No transactions with this filter.',
    receipt: 'Receipt',
    sent: 'Sent',
    printReceipt: 'Print Receipt',
    generating: 'Generating...',
    sendReceipt: 'Send Receipt',
    resendReceipt: 'Resend Receipt',
    sending: 'Sending...',
    copyTransactionId: 'Copy Transaction ID',
    transactionIdCopied: 'Transaction ID copied',
    receiptSentEmail: 'Receipt sent to your email',
    noActionsAvailable: 'No actions available',
    completed: 'Completed',
    pendingStatus: 'Pending',
    failed: 'Failed',
    refunded: 'Refunded',
    loadingPayments: 'Loading payment history...',
    loadingBilling: 'Loading billing...',
    loadingProfile: 'Loading candidate profile...',
    candidateNotFound: 'Candidate not found',
    candidateNotFoundDesc: 'Could not load candidate information.',
    summary: 'Summary',
    experienceTab: 'Experience',
    educationTab: 'Education',
    applicationTab: 'Application',
    contactInfo: 'Contact Information',
    email: 'Email',
    phone: 'Phone',
    locationLabel: 'Location',
    viewProfile: 'View Profile',
    skills: 'Skills',
    skillsMatchNote: 'Highlighted skills match the job requirements',
    aboutCandidate: 'About the Candidate',
    languages: 'Languages',
    quickSummary: 'Quick Summary',
    experiencesCount: 'Experiences',
    educationCount: 'Education',
    certificationsCount: 'Certifications',
    skillsCount: 'Skills',
    availability: 'Availability',
    canStart: 'Can start',
    salaryExpectation: 'Salary expectation',
    willingToRelocate: 'Willing to relocate',
    authorizedToWorkUSA: 'Authorized to work in USA',
    educationLevel: 'Education Level',
    viewLinkedIn: 'View LinkedIn',
    viewPortfolio: 'View Portfolio',
    noExperienceRegistered: 'No experience registered',
    noExperienceDesc: 'The candidate has not added work experience.',
    currentJob: 'Current Job',
    present: 'Present',
    highestEducation: 'Highest Education Level',
    noEducationDetail: 'No detailed education history',
    noEducationDesc: 'The candidate has not added education details.',
    certifications: 'Certifications',
    obtained: 'Obtained',
    expires: 'Expires',
    noExpiration: 'No expiration',
    applicationDetails: 'Application Details',
    position: 'Position',
    applicationDate: 'Application Date',
    matchScore: 'Match Score',
    coverLetter: 'Cover Letter',
    additionalInfo: 'Additional Information',
    availabilityLabel: 'Availability',
    relocation: 'Relocation',
    yesWilling: 'Yes, willing',
    no: 'No',
    yes: 'Yes',
    memberSince: 'Member since',
    excellentMatch: 'Excellent Match',
    goodMatch: 'Good Match',
    moderateMatch: 'Moderate Match',
    lowMatch: 'Low Match',
    immediately: 'Immediately',
    oneWeek: 'In 1 week',
    twoWeeks: 'In 2 weeks',
    oneMonth: 'In 1 month',
    negotiableAvail: 'Negotiable',
    lessThanHighSchool: 'No high school diploma',
    highSchool: 'High School Diploma / GED',
    someCollege: 'Some college',
    associate: 'Associate Degree',
    bachelor: "Bachelor's Degree",
    master: "Master's Degree",
    doctorate: 'Doctorate (PhD)',
    professional: 'Professional Degree',
    tradeCertificate: 'Trade Certificate',
    basic: 'Basic',
    intermediateLevel: 'Intermediate',
    advanced: 'Advanced',
    fluent: 'Fluent',
    native: 'Native',
    applicationInfo: 'Application Information',
    candidateInfo: 'Candidate Information',
    workExperience: 'Work Experience',
    educationHistory: 'Education History',
    timeline: 'Timeline',
    statusHistory: 'Status History',
    messageEmployer: 'Message Employer',
    messageCandidate: 'Message Candidate',
    // Jobs list table
    companyName: 'Company',
    freeTag: 'FREE',
    couponUsed: 'Coupon used',
    editTitle: 'Edit',
    pauseTitle: 'Pause',
    activateTitle: 'Activate',
    deleteTitle: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this job?',
    deletePaidWarning: '⚠️ IMPORTANT: This job has already been paid ($5). Deleting it will NOT result in any refund. Payments are final once the job is published.',
    deletePaidConfirm: 'Are you sure you want to delete this job? There will be NO refund.',
    deleteError: 'Error deleting job',
    updateError: 'Error updating job',
  },
};
